module.exports = __webpack_public_path__ + "static/media/HomeAuthenticated.dc8ff464.md";


//////////////////
// WEBPACK FOOTER
// ./src/md/HomeAuthenticated.md
// module id = 96
// module chunks = 0